import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './pages/Home';
import About from './pages/About';
import Programs from './pages/Programs';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';

import English from './pages/programs/English';
import Bengali from './pages/programs/Bengali';
import Math from './pages/programs/Math';
import Science from './pages/programs/Science';
import GlobalStudies from './pages/programs/GlobalStudies';
import AdditionalActivities from './pages/programs/AdditionalActivities';

import './styles/global.css';

import ScrollToHashElement from './components/ScrollToHashElement'

function App() {
  return (
    <Router>
      <ScrollToHashElement />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/programs" element={<Programs />} />

        <Route path="/programs/english" element={<English />} />
        <Route path="/programs/bengali" element={<Bengali />} />
        <Route path="/programs/math" element={<Math />} />
        <Route path="/programs/science" element={<Science />} />
        <Route path="/programs/globalstudies" element={<GlobalStudies />} />
        <Route path="/programs/additionalactivities" element={<AdditionalActivities />} />

        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;